export default __webpack_public_path__ + "static/media/customer01.d37a917e.jpg";